import { useCallback, useEffect, useState, useMemo } from 'react';
import { FaRegLightbulb, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { IoMdInformationCircle } from "react-icons/io";
import { Search, LoadingSpinner, CheckBox } from '../../../../components';
import * as S from './styled';
import { getTutorialsReport } from '../../../../service/serviceChat/tutorialService';

export function ViewTutorials() {
    const [status, setStatus] = useState('');
    const [required, setRequired] = useState(true);
    const [search, setSearch] = useState('');
    const [tutorialsList, setTutorialsList] = useState([]);
    const [loading, setLoading] = useState(false);

    const getListTutorials = useCallback(async () => {
        setLoading(true);
        try {
            const data = await getTutorialsReport(status, required ? true : undefined);
            setTutorialsList(data);
        } finally {
            setLoading(false);
        }
    }, [status, required]);

    useEffect(() => {
        getListTutorials()
    }, [getListTutorials]);


    const tutorialColumns = useMemo(() => {
        if (!tutorialsList?.users || tutorialsList.users.length === 0) return [];
        const firstUserWithTutorials = tutorialsList.users.find(u => u.tutorials && u.tutorials.length > 0) || tutorialsList.users[0];
        if (!firstUserWithTutorials || !firstUserWithTutorials.tutorials) return [];

        return firstUserWithTutorials.tutorials.map((tutorial, index) => ({
            key: tutorial.id || index,
            title: tutorial?.title || tutorial?.name || `Tutorial ${index + 1}`
        }));
    }, [tutorialsList]);

    const filteredUsers = useMemo(() => {
        if (!tutorialsList?.users) return [];
        return tutorialsList.users.filter(user =>
            user.nomecompleto?.toLowerCase().includes(search.toLowerCase())
        );
    }, [tutorialsList, search]);


    return (
        <S.Container>
            <S.Title>
                <span>
                    <FaRegLightbulb fontSize={'3rem'} />
                </span>
                <div>
                    {`Tutoriais e Documentos`}
                </ div>
            </S.Title>
            <S.Content>
                <div className="filters-bar">
                    <Search
                        className={`uFN`}
                        placeholder={`Buscar Usuário`}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <div className="filters-controls">
                        <div className='check--'>
                            <CheckBox
                                initialValue={required}
                                onChange={(value) => setRequired(value)}
                            />
                            <span className='check--label'>Obrigatórios</span>
                        </div>
                        <div className="filter-divider" />
                        <div className="filter-group">
                            <span>Status:</span>
                            <select
                                className={`uFS`}
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                            >
                                <option value="">{`Todos`}</option>
                                <option value="pending">{`Pendente`}</option>
                                <option value="progressing">{`Em Progresso`}</option>
                                <option value="finished">{`Finalizado`}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <S.TutorialsListContainer>
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', minHeight: '200px' }}>
                            <LoadingSpinner />
                        </div>
                    ) : (
                        <S.TableContainer>
                            <S.Table>
                                <thead>
                                    <tr>
                                        <th style={{ width: '40%' }}>Nome</th>
                                        {tutorialColumns.map((col, index) => (
                                            <th key={index} style={{ width: '1%', whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                <div title={col.title} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.25rem' }}>
                                                    {col.title.length > 10 ? `${col.title.slice(0, 10)}...` : col.title}
                                                    <IoMdInformationCircle size={16} style={{ color: '#1D86FF' }} />
                                                </div>
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredUsers.length > 0 ? (
                                        filteredUsers.map((user, index) => (
                                            <tr key={index}>
                                                <td>{user.nomecompleto || 'Sem Nome'}</td>
                                                {tutorialColumns.map((col, colIndex) => {
                                                    const userTutorial = user.tutorials && (user.tutorials.find(t => (t.title || t.name) === col.title) || user.tutorials[colIndex]);

                                                    return (
                                                        <td key={colIndex} style={{ textAlign: 'center' }}>
                                                            {userTutorial ? (
                                                                <S.StatusBadge status={userTutorial?.status}>
                                                                    {userTutorial?.status === 'pending' && 'Pendente'}
                                                                    {userTutorial?.status === 'progressing' && 'Em Progresso'}
                                                                    {userTutorial?.status === 'finished' && 'Finalizado'}
                                                                    {!['pending', 'progressing', 'finished'].includes(userTutorial?.status) && (userTutorial?.status || 'Desconhecido')}
                                                                </S.StatusBadge>
                                                            ) : (
                                                                <span>-</span>
                                                            )}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={2 + tutorialColumns.length} style={{ textAlign: 'center', padding: '1rem' }}>
                                                Nenhum usuário encontrado.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </S.Table>
                        </S.TableContainer>
                    )}
                </S.TutorialsListContainer>
            </S.Content>
        </S.Container >
    );
}